import {useEffect,useState} from "react";
export function navigate(path:string){history.pushState({},"",path);window.dispatchEvent(new PopStateEvent("popstate"))}
export function usePath(){const [path,setPath]=useState(location.pathname);useEffect(()=>{const update=()=>setPath(location.pathname);addEventListener("popstate",update);return()=>removeEventListener("popstate",update)},[]);return path}
